const config = {
    onUpdate: (registration)=>{
        caches.keys().then(cacheNames => {
            cacheNames.forEach(cacheName => {
              caches.delete(cacheName);
            });
          });

        registration.unregister();
    }
};

export default config;